import { Component, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, OnInit } from '@angular/core';
import { isArray } from 'util';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';

/**
 * カンマ編集テキストボックス
 *
 * @export
 * @class CommaFormatComponent
 * @extends {PlessInputTextDirective}
 * @implements {OnChanges}
 */
@Component({
  selector: 'app-comma-format',
  templateUrl: 'comma-format.component.html',
})
export class CommaFormatComponent implements OnInit, OnChanges {
  @ViewChild('label', { static: true }) public label: ElementRef;

  @Input() public subid: string = null;
  /** データ */
  @Input() Data: any;
  /** テキスト表示位置 */
  @Input() textAlign = String('');
  /** 値 */
  @Input() numberFomattedText = String('');
  /** 項目名 */
  @Input() valueName = String('');

  /**
   * 連携された値が変更された際に、メソッドを呼び出す
   *
   * @param {SimpleChanges} changes イベント引数
   * @memberof CommaFormatComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'Data':
          this.data = changes.Data.currentValue;
          break;
      }
    });
  }

  /**
   * データ設定
   *
   * @memberof CommaFormatComponent
   */
  public set data(value: any) {
    if (isArray(value)) {
      this.numberFomattedText = value[0];
    } else {
      this.numberFomattedText = value;
    }

    // 表示用文字列の編集
    if (!PlessViewUtilsSub.isEmpty(this.numberFomattedText)) {
        this.numberFomattedText = PlessViewUtilsSub.editPriceComma(this.numberFomattedText, true);
    }
  }

  /**
   * 初期処理
   *
   * @memberof CommaFormatComponent
   */
  ngOnInit(): void {
    this.label.nativeElement.setAttribute('id', this.subid + '_sub');
  }

}
